import { CheckboxState } from '../../model/types/agreements.types';
import { STEPS, Steps } from '../../model/utils/agreements.util';

export const getInitialCheckboxState = (
	steps: ReturnType<typeof STEPS>,
	latestTAC: boolean,
	latestPP: boolean,
): CheckboxState => {
	return steps.reduce((acc, step) => {
		if (step.title === Steps.TermsAndConditions) {
			acc[step.title] = [latestTAC, latestTAC];
		} else if (step.title === Steps.PrivacyPolicy) {
			acc[step.title] = [latestPP];
		} else {
			acc[step.title] = step.checkboxes?.map(() => false) ?? [];
		}

		return acc;
	}, {} as CheckboxState);
};
